export const SET_RESOURCE_FACETS = 'SET_RESOURCE_FACETS'
export const SET_CHECKED_FACET = 'SET_CHECKED_FACET'
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'
export const SET_REFERENCE_QUERY = 'SET_REFERENCE_QUERY'
export const SET_DATE_FILTER = 'SET_DATE_FILTER'
export const SET_RANGE_FILTER = 'SET_RANGE_FILTER'
export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS'
export const CLEAR_FILTER_FACET_VALUE = 'CLEAR_FILTER_FACET_VALUE'
export const CLEAR_RANGE_FILTER = 'CLEAR_RANGE_FILTER'
export const CLEAR_SPECIFIC_FACET_VALUE = 'CLEAR_SPECIFIC_FACET_VALUE'
export const SET_RESOURCE_INDEX = 'SET_RESOURCE_INDEX'

export const SET_QUERY_ARRAY_FACETS = 'SET_QUERY_ARRAY_FACETS'
export const SET_QUERY_NUMERIC_FILTER = 'SET_QUERY_NUMERIC_FILTER'
export const SET_QUERY_RANGE_FILTER = 'SET_QUERY_RANGE_FILTER'
export const SET_QUERY_PAGE = 'SET_QUERY_PAGE'
export const SET_QUERY_SEARCH_TEXT = 'SET_QUERY_SEARCH_TEXT'
export const SET_QUERY_SEARCH_REF = 'SET_QUERY_SEARCH_REF'
